import { RESET_VIEW_GLOBAL } from 'store/global/actionType';
import Enums from 'utils/EnumsManager';

const { REDUX_ACTION_TYPE_PREFIX } = Enums;
const { VIEWFILTER } = REDUX_ACTION_TYPE_PREFIX;

export const RESET_VIEW = RESET_VIEW_GLOBAL;
export const DONE = `${VIEWFILTER}_DONE`;
export const IS_CREATED_BY_ME = `${VIEWFILTER}_IS_CREATED_BY_ME`;



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/ViewActions/flow/actionTypes.js